import { useEffect, useState } from 'react';
import { AppState } from 'react-native';

export function useIsForeground() {
  const [isForeground, setForeground] = useState(AppState.currentState === 'active');

  useEffect(() => {
    const listener = AppState.addEventListener('change', () => setForeground(AppState.currentState === 'active'));
    return () => {
      listener.remove();
    };
  }, []);

  return {
    isForeground,
  };
}
